import React from "react";

export function CheckedIllustration({ ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="64"
        cy="64"
        r="39.3"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M44 63.7447L59.6522 76L84 52"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
